import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import { lightGrey, darkGrey, universalStyles } from '../../../../app/theme';
import history from '../../../../services/browserHistory';
import LEARNING_CHECK, { LearningCheckFormat } from '../../../../constants/learningCheck.constants';
import { BASE_URL, IMAGE_PATHS } from '../../../../constants/paths.constants';
import SingleQuestionReview from '../../../micro/learningCheck/SingleQuestionReview';
import TrainingNavBar from '../../../micro/TrainingNavBar/AxuminTrainingNavBar';
import AxuminNavBar from '../../../micro/BrandNavBar/AxuminNavBar';
import Indication from '../../../micro/Indication/AxuminIndication';
import TrainingFooter from '../../../micro/TrainingFooter/TrainingFooter';

const useStyles = makeStyles(() => ({
  ...universalStyles,
  grayBox: {
    backgroundColor: darkGrey,
    width: '100%',
    margin: 0,
    paddingBottom: 56,
  },
  content: {
    maxWidth: 1242,
    margin: 'auto',
  },
  headerRow: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    padding: '40px 0',
    borderBottom: `1px solid ${lightGrey}`,
    marginBottom: 50,
  },
  icon: {
    height: 119,
    paddingRight: 40,
  },
  header: {
    margin: 0,
  },
}));

const LearningCheckReview = (): JSX.Element => {
  const classes = useStyles();
  const [displayModule, setDisplayModule] = useState('');
  const [questionsArray, setQuestionsArray] = useState<LearningCheckFormat[]>([]);

  useEffect(() => {
    const path = history.location.pathname;
    let module = '';
    if (path.indexOf('acquisition') >= 0) module = 'axuminAcquisition';
    else if (path.indexOf('interpretation') >= 0) module = 'axuminInterpretation';

    const first = module[0].toUpperCase();
    setDisplayModule(`${first}${module.substring(1)}`);

    document.title = `Comprehensive Review of Learning Checks (${first}${module.substring(1)}) `;

    const tempArray: LearningCheckFormat[] = [];
    Object.keys(LEARNING_CHECK[module]).forEach((key) => {
      tempArray.push(...LEARNING_CHECK[module][key]);
    });
    setQuestionsArray(tempArray);
  }, []);

  return (
    <>
      <TrainingNavBar />
      <AxuminNavBar section={`Image ${displayModule}`} />
      <div className={classes.grayBox}>
        <div className={classes.content}>
          <div className={classes.headerRow}>
            <img
              className={classes.icon}
              src={`${BASE_URL}${IMAGE_PATHS.LEARNING_CHECK_ICONS[1].LEARNING_CHECK_ICON.path}`}
              alt={`${IMAGE_PATHS.LEARNING_CHECK_ICONS[1].LEARNING_CHECK_ICON.alt}`}
            />
            <Typography variant="h1" className={classes.header}>
              Comprehensive Review of Learning Checks
            </Typography>
          </div>
          <div className={classes.grayBox}>
            {questionsArray.map((question) => (
              <SingleQuestionReview key={question.number} thisQuestion={question} />
            ))}
          </div>
        </div>
      </div>
      <Indication />
      <TrainingFooter />
    </>
  );
};

export default LearningCheckReview;
